// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-forecast {
  background: linear-gradient(135deg, var(--bg-card) 0%, var(--bg-secondary) 100%);
  border-radius: var(--radius-lg);
  border: 2px solid var(--border-color);
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.tv-forecast.compact {
  padding: var(--spacing-sm) var(--spacing-md);
  border-width: 1px;
}

.tv-forecast-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  color: var(--accent-blue);
}

.tv-forecast.compact .tv-forecast-header {
  margin-bottom: var(--spacing-sm);
}

.tv-forecast.compact .tv-forecast-header h3 {
  font-size: 0.9rem;
}

.tv-forecast-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.tv-forecast.compact .tv-forecast-header h3 {
  font-size: 1rem;
}

/* Full Forecast List */
.tv-forecast-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  flex: 1 1;
}

.tv-forecast-day {
  display: grid;
  grid-template-columns: 120px 150px 80px 1fr 100px;
  align-items: center;
  gap: var(--spacing-lg);
  padding: var(--spacing-lg);
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  transition: all var(--transition-fast);
}

.tv-forecast-day:hover {
  background: rgba(0, 0, 0, 0.3);
  border-color: var(--border-color);
}

.tv-forecast-day.today {
  background: rgba(59, 130, 246, 0.1);
  border-color: var(--accent-blue);
}

.tv-forecast-day-name {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.day-name {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--text-primary);
}

.today-badge {
  font-size: 0.75rem;
  padding: 2px 8px;
  background: var(--accent-blue);
  color: white;
  border-radius: var(--radius-sm);
  width: fit-content;
}

.tv-forecast-icon {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.tv-forecast-icon img {
  width: 50px;
  height: 50px;
}

.condition-text {
  font-size: 1rem;
  color: var(--text-secondary);
}

.tv-forecast-precip {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--accent-blue);
  font-size: 1.1rem;
}

.no-precip {
  color: var(--text-muted);
}

.tv-forecast-temps {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.temp-high {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--accent-orange);
  min-width: 50px;
  text-align: right;
}

.temp-low {
  font-size: 1.4rem;
  color: var(--accent-blue);
  min-width: 50px;
}

.temp-bar {
  flex: 1 1;
  height: 8px;
  background: var(--bg-secondary);
  border-radius: 4px;
  overflow: hidden;
}

.temp-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-blue), var(--accent-cyan), var(--accent-orange));
  border-radius: 4px;
  min-width: 20%;
}

.tv-forecast-wind {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--text-secondary);
  font-size: 1rem;
}

/* Compact Forecast List */
.tv-forecast-compact-list {
  display: flex;
  gap: var(--spacing-xs);
  flex: 1 1;
  min-height: 0;
  align-items: stretch;
}

.tv-forecast-compact-day {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: var(--spacing-xs) var(--spacing-xs);
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
  transition: all var(--transition-fast);
  min-height: 0;
  overflow: hidden;
}

.tv-forecast-compact-day:hover {
  background: rgba(0, 0, 0, 0.3);
}

.tv-forecast-compact-day.today {
  background: rgba(59, 130, 246, 0.15);
  border-color: var(--accent-blue);
}

.compact-day-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.tv-forecast-compact-day.today .compact-day-name {
  color: var(--accent-blue);
}

.compact-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.compact-temps {
  display: flex;
  gap: var(--spacing-xs);
  font-size: 0.85rem;
}

.compact-high {
  font-weight: 600;
  color: var(--text-primary);
}

.compact-low {
  color: var(--text-muted);
}

.compact-precip {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 0.75rem;
  color: var(--accent-blue);
}

/* Responsive */
@media (max-width: 1200px) {
  .tv-forecast-day {
    grid-template-columns: 100px 120px 60px 1fr 80px;
    padding: var(--spacing-md);
  }
  
  .day-name {
    font-size: 1.1rem;
  }
  
  .tv-forecast-icon img {
    width: 40px;
    height: 40px;
  }
  
  .temp-high,
  .temp-low {
    font-size: 1.2rem;
  }
}

@media (max-width: 900px) {
  .tv-forecast-day {
    grid-template-columns: 80px 1fr 60px;
  }
  
  .tv-forecast-icon,
  .tv-forecast-wind {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TV/TVForecast.css"],"names":[],"mappings":"AAAA;EACE,gFAAgF;EAChF,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gGAAgG;EAChG,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4CAA4C;EAC5C,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,gDAAgD;IAChD,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".tv-forecast {\n  background: linear-gradient(135deg, var(--bg-card) 0%, var(--bg-secondary) 100%);\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--border-color);\n  padding: var(--spacing-xl);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.tv-forecast.compact {\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-width: 1px;\n}\n\n.tv-forecast-header {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n  color: var(--accent-blue);\n}\n\n.tv-forecast.compact .tv-forecast-header {\n  margin-bottom: var(--spacing-sm);\n}\n\n.tv-forecast.compact .tv-forecast-header h3 {\n  font-size: 0.9rem;\n}\n\n.tv-forecast-header h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.tv-forecast.compact .tv-forecast-header h3 {\n  font-size: 1rem;\n}\n\n/* Full Forecast List */\n.tv-forecast-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n  flex: 1;\n}\n\n.tv-forecast-day {\n  display: grid;\n  grid-template-columns: 120px 150px 80px 1fr 100px;\n  align-items: center;\n  gap: var(--spacing-lg);\n  padding: var(--spacing-lg);\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius-md);\n  border: 1px solid transparent;\n  transition: all var(--transition-fast);\n}\n\n.tv-forecast-day:hover {\n  background: rgba(0, 0, 0, 0.3);\n  border-color: var(--border-color);\n}\n\n.tv-forecast-day.today {\n  background: rgba(59, 130, 246, 0.1);\n  border-color: var(--accent-blue);\n}\n\n.tv-forecast-day-name {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.day-name {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.today-badge {\n  font-size: 0.75rem;\n  padding: 2px 8px;\n  background: var(--accent-blue);\n  color: white;\n  border-radius: var(--radius-sm);\n  width: fit-content;\n}\n\n.tv-forecast-icon {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.tv-forecast-icon img {\n  width: 50px;\n  height: 50px;\n}\n\n.condition-text {\n  font-size: 1rem;\n  color: var(--text-secondary);\n}\n\n.tv-forecast-precip {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  color: var(--accent-blue);\n  font-size: 1.1rem;\n}\n\n.no-precip {\n  color: var(--text-muted);\n}\n\n.tv-forecast-temps {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.temp-high {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--accent-orange);\n  min-width: 50px;\n  text-align: right;\n}\n\n.temp-low {\n  font-size: 1.4rem;\n  color: var(--accent-blue);\n  min-width: 50px;\n}\n\n.temp-bar {\n  flex: 1;\n  height: 8px;\n  background: var(--bg-secondary);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.temp-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent-blue), var(--accent-cyan), var(--accent-orange));\n  border-radius: 4px;\n  min-width: 20%;\n}\n\n.tv-forecast-wind {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  color: var(--text-secondary);\n  font-size: 1rem;\n}\n\n/* Compact Forecast List */\n.tv-forecast-compact-list {\n  display: flex;\n  gap: var(--spacing-xs);\n  flex: 1;\n  min-height: 0;\n  align-items: stretch;\n}\n\n.tv-forecast-compact-day {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: var(--spacing-xs) var(--spacing-xs);\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius-sm);\n  border: 1px solid transparent;\n  transition: all var(--transition-fast);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.tv-forecast-compact-day:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.tv-forecast-compact-day.today {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: var(--accent-blue);\n}\n\n.compact-day-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.tv-forecast-compact-day.today .compact-day-name {\n  color: var(--accent-blue);\n}\n\n.compact-icon {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n}\n\n.compact-temps {\n  display: flex;\n  gap: var(--spacing-xs);\n  font-size: 0.85rem;\n}\n\n.compact-high {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.compact-low {\n  color: var(--text-muted);\n}\n\n.compact-precip {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 0.75rem;\n  color: var(--accent-blue);\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .tv-forecast-day {\n    grid-template-columns: 100px 120px 60px 1fr 80px;\n    padding: var(--spacing-md);\n  }\n  \n  .day-name {\n    font-size: 1.1rem;\n  }\n  \n  .tv-forecast-icon img {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .temp-high,\n  .temp-low {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .tv-forecast-day {\n    grid-template-columns: 80px 1fr 60px;\n  }\n  \n  .tv-forecast-icon,\n  .tv-forecast-wind {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
